export default __webpack_public_path__ + "static/media/people.3e119e72.jpg";